import { render, staticRenderFns } from "./AppTableChargeRequests.vue?vue&type=template&id=28b922b6&"
import script from "./AppTableChargeRequests.vue?vue&type=script&lang=ts&"
export * from "./AppTableChargeRequests.vue?vue&type=script&lang=ts&"
import style0 from "./AppTableChargeRequests.vue?vue&type=style&index=0&id=28b922b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports